// Testi e utilita' del nodo ifCondition (card #10389325988), condivisi da nodo
// canvas e pannello. IF_OPERATORS e' lo specchio di OPERATORS in
// apps/backend/src/services/flow/utils/ifRules.js: tenerli allineati.

export const IF_OPERATORS = [
  'is_empty', 'is_not_empty',
  'equals', 'not_equals',
  'contains', 'not_contains',
  'greater_than', 'less_than', 'greater_or_equal', 'less_or_equal',
];
export const VALUELESS_OPERATORS = new Set(['is_empty', 'is_not_empty']);
export const NUMERIC_OPERATORS = new Set(['greater_than', 'less_than', 'greater_or_equal', 'less_or_equal']);

const MAX_RULES_IN_SUMMARY = 2;

export function cleanVariableName(name) {
  return String(name ?? '').trim().replace(/^\{\{\s*/, '').replace(/\s*\}\}$/, '').trim();
}

export function looksNumeric(value) {
  const s = String(value ?? '').trim();
  if (/\{\{.+\}\}/.test(s)) return true;
  return /^[-+]?(\d+([.,]\d+)?|[.,]\d+)$/.test(s);
}

export function ruleText(rule, t) {
  const variable = cleanVariableName(rule?.variable) || t('flowEditor.nodes.ifConditionNode.emptyVariable');
  const operator = t(`flowEditor.ifOperators.${rule?.operator || 'equals'}`);
  if (VALUELESS_OPERATORS.has(rule?.operator)) return `${variable} ${operator}`;
  return `${variable} ${operator} "${rule?.value ?? ''}"`;
}

export function branchSummary(branch, t) {
  const rules = Array.isArray(branch?.rules) ? branch.rules.filter(Boolean) : [];
  if (rules.length === 0) return t('flowEditor.nodes.ifConditionNode.noRules');
  const joiner = t(branch.match === 'any' ? 'flowEditor.nodes.ifConditionNode.or' : 'flowEditor.nodes.ifConditionNode.and');
  if (rules.length > MAX_RULES_IN_SUMMARY) {
    return `${ruleText(rules[0], t)} ${joiner} ${t('flowEditor.nodes.ifConditionNode.moreRules', { n: rules.length - 1 })}`;
  }
  return rules.map(r => ruleText(r, t)).join(` ${joiner} `);
}

export function branchName(branch, index, t) {
  return (branch?.label || '').trim() || t('flowEditor.nodes.ifConditionNode.branchFallback', { n: index + 1 });
}

function nextId(prefix, existing) {
  const re = new RegExp(`^${prefix}(\\d+)$`);
  const max = (existing || []).reduce((m, item) => {
    const match = re.exec(String(item?.id ?? ''));
    return match ? Math.max(m, Number(match[1])) : m;
  }, 0);
  return `${prefix}${max + 1}`;
}
export const newBranchId = (branches) => nextId('b', branches);
export const newRuleId = (rules) => nextId('r', rules);

// Campi con cui i nodi del flusso scrivono una variabile nel contesto.
const VARIABLE_FIELDS = ['variableName', 'targetVariable', 'responseVariable', 'resultVariable', 'outputVariable'];

export function collectFlowVariables(nodes = []) {
  const names = new Set();
  for (const node of nodes) {
    const d = node?.data || {};
    for (const field of VARIABLE_FIELDS) {
      const name = cleanVariableName(d[field]);
      if (name) names.add(name);
    }
    if (Array.isArray(d.parameters)) {
      for (const p of d.parameters) {
        const name = cleanVariableName(p?.name);
        if (name) names.add(name);
      }
    }
  }
  return [...names].sort();
}
